import React from 'react';

import { useConceptManagement } from '../../../../main/scripts/data_hooks';
import {
  CancelButton,
  RebuildModal
} from '../../../../main/scripts/project_management/RebuildModal';

export const RebuildProjectModal = ({
  project,
  username,
  serverStatus,
  onClose
}) => {
  const { conceptManagement } = useConceptManagement(project);
  return (
    <RebuildModal
      forcedRebuild
      project={project}
      userEmail={username}
      serverStatus={serverStatus}
      cancelButton={<CancelButton onClick={onClose} />}
      onAfterRebuild={() => {
        window.location.href = `/app/projects/${project.workspace_id}/${project.project_id}`;
      }}
      conceptManagement={conceptManagement}
      onHide={onClose}
    />
  );
};
